import { useMemo } from 'react';
import { useLocation } from 'react-router';

/**
 * Returns the current path + search as a `previousLocation` state object,
 * ready to spread into a `navigate()` call's `state`.
 *
 * Usage:
 * ```ts
 * const previousLocationState = usePreviousLocationState();
 * navigate(targetRoute, { state: { ...previousLocationState, ...otherState } });
 * ```
 */
export const usePreviousLocationState = () => {
    const location = useLocation();
    return useMemo(
        () => ({ previousLocation: location.pathname + location.search }),
        [ location.pathname, location.search ],
    );
};
